exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.demo-dynamic[data-v-367c502f]{\n  background-color: #f6f6f6;\n  padding: 15px;\n}\n", ""]);

// exports
